import { TranslationsContext } from '@teliaee/telia-translate';
import { inject } from 'mobx-react';
import * as React from 'react';

import {
  Grid,
  Anchor,
  GridColumn,
  Select,
  Search,
  Separator,
  Table,
  ISearchProps,
  TSelectValue,
  ISelectObjectProps,
  AnalyticsTrigger,
  TableCell
} from 'telia-front-react';
import JobOffersStore from '../stores/JobOffersStore';

export interface JobListProps {
  jobOffersStore?: JobOffersStore;
  type?: string;
  positionSelect: ISelectObjectProps;
  countrySelect?: ISelectObjectProps;
  citySelect: ISelectObjectProps;
  resultHeaders: string[];
  results: JobListResultProps[];
  careersText: string;
  careersLink: string;
  careersNote: string;
  search: ISearchProps;
}

export interface JobListResultProps {
  id: string;
  name: string;
  link: string;
  country: string;
  city: string;
  date: string;
}

class TemplateJobList extends React.Component<JobListProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  render() {
    const store = this.props.jobOffersStore;
    const type = this.props.type;
    return (
      <div>
        <Grid align={['bottom-xs']}>
          <GridColumn width={['md-6', 'lg-3']}>
            <Select {...this.props.positionSelect} onChange={(selectValue: TSelectValue) => store.setSelectedPosition(selectValue, type)} />
          </GridColumn>
          {this.props.countrySelect && (
            <GridColumn width={['md-6', 'lg-3']}>
              <Select {...this.props.countrySelect} onChange={(newValue: TSelectValue) => store.setSelectedCountry(newValue, type, this.context.translate)} />
            </GridColumn>
          )}
          <GridColumn width={['md-6', 'lg-3']}>
            <Select
              {...store.getCitySelectOptions(type, this.context.translate)}
              onChange={(newValue: TSelectValue) => store.setSelectedCity(newValue, type)}
            />
          </GridColumn>
          <GridColumn width={['md-6', 'lg-3']}>
            <Search {...this.props.search} onChange={(value) => store.setSearchTerm(value, this.props.type)} onSubmit={(event) => event.preventDefault()} />
          </GridColumn>
        </Grid>

        <Separator spacing="small" color="invisible" />

        <Table responsive="cols">
          <thead>
            <tr>{this.props.resultHeaders.map((item) => this.mapHeaders(item))}</tr>
          </thead>
          <tbody>{this.props.results.map((item) => this.mapResults(item))}</tbody>
        </Table>

        <Separator spacing="small" color="invisible" />
        <AnalyticsTrigger trigger={{ id: 'Link - Kandideerimiseks on soovitav luua konto', callback: 'onClick' }}>
          <Anchor url={this.props.careersLink} target="_blank">
            {this.props.careersText}
          </Anchor>
        </AnalyticsTrigger>
        <p>{this.props.careersNote}</p>
      </div>
    );
  }

  private mapHeaders = (item: string) => {
    return (
      <TableCell type="th" scope="col" key={item}>
        {item}
      </TableCell>
    );
  };

  private mapResults = (item: JobListResultProps) => {
    return (
      <tr key={item.id}>
        <TableCell>
          <AnalyticsTrigger trigger={{ id: `Link - ${item.name}`, callback: 'onClick' }}>
            <Anchor url={item.link} target="_blank">
              {item.name}
            </Anchor>
          </AnalyticsTrigger>
        </TableCell>
        <TableCell>{item.country}</TableCell>
        <TableCell>{item.city}</TableCell>
        <TableCell>{item.date}</TableCell>
      </tr>
    );
  };
}
export default inject('jobOffersStore')(TemplateJobList);
